module.exports = __webpack_public_path__ + "static/img/brand2.a11bdc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/brand/brand2.png
// module id = I1AF
// module chunks = 1